module.exports = __webpack_public_path__ + "Roboto-LightItalic.c7b4e746cf8ecbf412fc.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.woff
// module id = 136
// module chunks = 16